// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"204":"95b3e469","249":"d1148d02","444":"d20cd9b2","542":"56decca5","571":"f9359377","712":"c22598c9","810":"671a547e"}[chunkId] + ".js";
};